/**
 * coursesApi.js
 * -------------
 * API client for Courses Master using createMasterApiClient.
 * Connects directly to FastAPI backend /courses/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

const coursesClient = createMasterApiClient('courses');

export async function listCourses(params = {}) {
  return await coursesClient.list(params);
}

export async function getCourseDetail(courseId) {
  return await coursesClient.getById(courseId);
}

export async function createCourse(payload) {
  return await coursesClient.create(payload);
}

export async function updateCourse(courseId, payload) {
  return await coursesClient.update(courseId, payload);
}

export async function archiveCourse(courseId) {
  return await coursesClient.archive(courseId);
}

export async function deleteCourse(courseId) {
  return await coursesClient.remove(courseId);
}

export async function getCourseOptions() {
  return await coursesClient.getDropdownOptions();
}
